module.exports = __webpack_public_path__ + "static/media/circle-status-financed.de8f9089.svg";